export default __webpack_public_path__ + "static/media/verificationEmail.3f71daab.png";